import { IsBoolean, IsInt, IsNotEmpty, IsNumber, IsString } from '@pristine-ts/class-validator';
import { ErrorMessageBuilder } from '../../../../../../common/src/builders/error-message.builder';

export class RolloverPropertyTransferredCommonSharesClassResult {
  // StringType
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  id: string;

  // StringType
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  title: string;

  // BooleanType
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  isRightToResidual: boolean;

  // BooleanType
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  isRightToVote: boolean;

  // BooleanType
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  isRightToParticipate: boolean;

  // NumberType
  @IsNumber(undefined, { buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  numberOfShares: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  fairMarketValue: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  paidUpCapitalPerShare: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  adjustedCostBase: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  totalAdjustedCostBase: number;

  totalFairMarketValue: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  paidUpCapital: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  totalPaidUpCapital: number;

  numberOfCommonSharesInCirculation: number;
}